import { translationParamsVar } from "graphql/cache";
import { AI_TRANSLATION_ENABLED } from "mock-data/translation/languages";
import errorNotification from "components/request-result/error-notification";

import graphqlTranslateItems, { hasGraphqlTranslationAccess } from "./translation-graphql-client";
import {
    TRANSLATION_ERROR_TYPES,
    createTranslationError,
    isRateLimitedTranslationError,
    isRetryableTranslationError,
    normalizeTranslationError,
    shouldDisableTranslationApi
} from "./translation-ai-errors";


let translationErrorNotified = false;

export const getTranslationApiAccessError = () => {
    if (!AI_TRANSLATION_ENABLED) {
        return createTranslationError(
            TRANSLATION_ERROR_TYPES.disabled,
            "AI translation is disabled by configuration",
            { retryable: false }
        );
    }

    return null;
};

export const hasTranslationApiAccess = (translationParams = translationParamsVar()) => {
    if (!AI_TRANSLATION_ENABLED) return false;
    if (translationParams.translationApiUnavailable) return false;

    return hasGraphqlTranslationAccess();
};

export const showTranslationErrorNotification = (error) => {
    if (translationErrorNotified) return false;

    const normalizedError = normalizeTranslationError(error);

    translationErrorNotified = true;

    errorNotification({
        label  : normalizedError.label,
        reason : normalizedError.reason
    });

    return true;
};

export const markTranslationApiUnavailable = (error) => {
    const normalizedError = normalizeTranslationError(error);

    if (!shouldDisableTranslationApi(normalizedError)) return false;

    const currentParams = translationParamsVar();

    if (!currentParams.translationApiUnavailable) {
        translationParamsVar({
            ...currentParams,
            translationApiUnavailable: true
        });
    }

    showTranslationErrorNotification(normalizedError);

    return true;
};

export const translateItems = async (params) => {
    if (!AI_TRANSLATION_ENABLED) {
        throw createTranslationError(
            TRANSLATION_ERROR_TYPES.disabled,
            "AI translation is disabled by configuration",
            { retryable: false }
        );
    }

    try {
        return await graphqlTranslateItems(params);
    } catch (error) {
        throw normalizeTranslationError(error);
    }
};

export {
    TRANSLATION_ERROR_TYPES,
    createTranslationError,
    isRateLimitedTranslationError,
    isRetryableTranslationError,
    normalizeTranslationError,
    shouldDisableTranslationApi
};

export default translateItems;
